import React from 'react';
import usePreferencesContext from '../contexts/preferences';
import SwitchToggle from './SwitchToggle';

const SwitchToggleTimeFormat = () => {
  const preferences = usePreferencesContext();

  const handleChangeTimeFormat = (checked) => {
    preferences.updatePreferences('timeFormat', checked ? '24h' : '12h');
  };

  return (
    <SwitchToggle
      checked={preferences.state.timeFormat === '24h'}
      onChange={handleChangeTimeFormat}
      label="24H"
    />
  );
};

export default SwitchToggleTimeFormat;
